import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-expired-products-dialog',
  templateUrl: './expired-products-dialog.component.html',
  styleUrls: ['./expired-products-dialog.component.scss'],
})
export class ExpiredProductsDialogComponent {
  public expiredProducts: any[];

  constructor(
    public dialogRef: MatDialogRef<ExpiredProductsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.expiredProducts = data.expiredProducts || [];
    dialogRef.disableClose = false;
  }

  public close(): void {
    this.dialogRef.close();
  }
}
